var _REPEAT_ICONS;

import React from 'react';
import { bgImageRepeats, positions, sizes } from "../../../../enums";
import Label from "../../../core/label";
import IconMenu from "../../../core/icon-menu";

function MediaSettingsRepeatMenu(_ref) {
  var onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? bgImageRepeats.NO_REPEAT : _ref$value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Image repeat' : _ref$label;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    text: label
  }), /*#__PURE__*/React.createElement(IconMenu, {
    id: "repeat",
    items: REPEAT_OPTIONS,
    activeValue: value,
    size: sizes.X5,
    onItemClick: onChange
  }));
}
/** ########################################################################################
    PRIVATE HELPERS
    ######################################################################################## */


var REPEAT_ICONS = (_REPEAT_ICONS = {}, _REPEAT_ICONS[bgImageRepeats.NO_REPEAT] = /*#__PURE__*/React.createElement("svg", {
  id: "bg-repeat-no-repeat",
  width: "50",
  height: "50",
  viewBox: "0 0 49 49",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-block-element",
  fill: "#D3D8DB",
  d: "M0 0h49v49H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  fill: "#B1B8BE",
  d: "M5 5h39v39H5z"
}))), _REPEAT_ICONS[bgImageRepeats.REPEAT_X] = /*#__PURE__*/React.createElement("svg", {
  id: "bg-repeat-repeat-x",
  width: "50",
  height: "50",
  viewBox: "0 0 49 49",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-block-element",
  fill: "#D3D8DB",
  d: "M0 0h49v49H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  fill: "#B1B8BE",
  d: "M5 19h11v11H5zM19 19h11v11H19zM33 19h11v11H33z"
}))), _REPEAT_ICONS[bgImageRepeats.REPEAT_Y] = /*#__PURE__*/React.createElement("svg", {
  id: "bg-repeat-repeat-y;",
  width: "50",
  height: "50",
  viewBox: "0 0 49 49",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-block-element",
  fill: "#D3D8DB",
  d: "M0 0h49v49H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  fill: "#B1B8BE",
  d: "M19 5h11v11H19zM19 19h11v11H19zM19 33h11v11H19z"
}))), _REPEAT_ICONS[bgImageRepeats.REPEAT] = /*#__PURE__*/React.createElement("svg", {
  id: "bg-repeat-repeat",
  width: "50",
  height: "50",
  viewBox: "0 0 49 49",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-block-element",
  fill: "#D3D8DB",
  d: "M0 0h49v49H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  fill: "#B1B8BE",
  d: "M5 5h11v11H5zM19 5h11v11H19zM33 5h11v11H33zM5 19h11v11H5zM19 19h11v11H19zM33 19h11v11H33zM5 33h11v11H5zM19 33h11v11H19zM33 33h11v11H33z"
}))), _REPEAT_ICONS);
var REPEAT_OPTIONS = [{
  tooltip: 'Display once',
  value: bgImageRepeats.NO_REPEAT,
  icon: REPEAT_ICONS[bgImageRepeats.NO_REPEAT]
}, {
  tooltip: 'Repeat horizontally',
  value: bgImageRepeats.REPEAT_X,
  icon: REPEAT_ICONS[bgImageRepeats.REPEAT_X]
}, {
  tooltip: 'Repeat vertically',
  value: bgImageRepeats.REPEAT_Y,
  icon: REPEAT_ICONS[bgImageRepeats.REPEAT_Y]
}, {
  tooltip: 'Tile to fill space',
  tooltipPosition: positions.TOP_LEFT,
  value: bgImageRepeats.REPEAT,
  icon: REPEAT_ICONS[bgImageRepeats.REPEAT]
}];
export default MediaSettingsRepeatMenu;
//# sourceMappingURL=media-settings-repeat-menu.js.map